import { Redirect } from 'react-router-dom';
import { PersonSVG } from 'src/assets/svg';
import { CardGrid } from 'src/components/AppScreen/AppLayout';
import Card from 'src/components/Card';
import { IncompleteSessions } from './IncompleteSessions';
import { useTranslation } from 'react-i18next';
import { useSignedInUser } from 'src/view/hooks/useSignedInUser';
import {
    getPrimaryRole,
    isOrganizationAdministrator,
    UserRole,
} from 'src/domain/user';

export const Home = () => {
    const { t } = useTranslation();
    const user = useSignedInUser();
    const role = getPrimaryRole(user);
    const canCreateUsers =
        !user?.supportMode && isOrganizationAdministrator(user);

    if (
        (role === UserRole.creator && !isOrganizationAdministrator(user)) ||
        user?.supportMode
    ) {
        return <Redirect to="/app/users" />;
    }

    return (
        <div className="flex flex-col space-y-10 text-xl">
            <CardGrid>
                {canCreateUsers && (
                    <>
                        <Card
                            label={t('home.shortcuts.newUser')}
                            shape="circle"
                            to="/app/users/new"
                        >
                            <PersonSVG className="w-[18px] h-[18px]" />
                        </Card>
                        <Card
                            label={t('home.shortcuts.newCreator')}
                            shape="circle"
                            to="/app/creators/new"
                        >
                            <PersonSVG className="w-[18px] h-[18px]" />
                        </Card>
                    </>
                )}
                {/* <Card
                    label={t('home.shortcuts.newVideo')}
                    shape="circle"
                    disabled={shortCutsDisabled}
                    to="/app/new-video/step1"
                >
                    <TextIcon SVG={VideoIcon} />
                </Card>
                <Card
                    label={t('home.shortcuts.uploadImages')}
                    shape="circle"
                    disabled={shortCutsDisabled}
                    to="/app/image-upload"
                >
                    <TextIcon SVG={ImagesIcon} />
                </Card> */}
            </CardGrid>

            <IncompleteSessions />
        </div>
    );
};
